/**
 * settingsModal - shared modal chrome and labeled-field wrapper for the admin
 * settings panels (Users, Teams). Extracted from UsersSection so TeamsSection
 * does not duplicate the same markup; both consumers keep the same visual
 * behavior as before.
 */
import { Label } from "../ui/label";

export function ModalShell(props: {
  title: string;
  onClose: () => void;
  wide?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 py-10"
      onClick={(e) => {
        if (e.target === e.currentTarget) props.onClose();
      }}
    >
      {/*
        Height-capped and scrollable: the manage-user dialog is taller than a
        laptop viewport, and an overflowing centred panel spills past both edges
        with no way to reach the top — the section at the top of the dialog was
        simply unreachable.
      */}
      <div
        className={`max-h-full w-full overflow-y-auto ${props.wide ? "max-w-2xl" : "max-w-md"} rounded-2xl border border-border/60 bg-card p-6 shadow-2xl`}
      >
        <div className="mb-3 flex items-center justify-between">
          <h3 className="text-base font-semibold">{props.title}</h3>
          <button
            type="button"
            onClick={props.onClose}
            className="rounded p-1 text-muted-foreground hover:bg-muted/40"
          >
            ✕
          </button>
        </div>
        {props.children}
      </div>
    </div>
  );
}

export function Field(props: { label: string; children: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label className="text-xs">{props.label}</Label>
      {props.children}
    </div>
  );
}
